import React from 'react';

import { StyleSheet } from 'react-native';
import { withTypography } from 'ucl/components/text/Typography';

import { Box, BoxProps } from 'components/ui';
import { getDesignToken, primitive, spacing } from 'styles/constants';

export const Container = ({ style, ...props }: BoxProps) =>
  React.createElement(Box, { ...props, style: [styles.container, style] });

export const Price = withTypography({ m: '$0', color: getDesignToken('color-validated') });

export const GreyStyledText = withTypography({ m: '$0', color: primitive.$greySix });

export const Divider = withTypography({ my: '$0', color: primitive.$greyTwo, mx: '$1' });

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    marginTop: spacing.$1,
  },
});
